import axios from 'utils/axios';
import type {
    GetProductSetListResultType,
    ProductSetCreateDataType,
    ProductSetFullType,
    ProductSetSaveDataType,
} from '@econtractor/types';

export interface ProductSetListParams {
    page?: number;
    search?: string;
    order?: string;
    onPage?: number;
}

export type ProductSetPayload = ProductSetCreateDataType & ProductSetSaveDataType;

export interface ProductSetCreateResponse {
    setId?: number;
    articleDublicate?: boolean;
}

export const getList = async (getData: ProductSetListParams): Promise<GetProductSetListResultType | null> => {
    try {
        const response = await axios('/product-sets', { params: getData });
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getProductSet = async (setId: number | string): Promise<ProductSetFullType | null> => {
    try {
        const response = await axios(`/product-sets/${setId}`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const createProductSet = async (createData: ProductSetPayload): Promise<number | false | ProductSetCreateResponse> => {
    try {
        const response = await axios.post('/product-sets/new', createData);
        if (response?.data?.articleDublicate) return response.data as ProductSetCreateResponse;
        return response?.data?.setId || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const updateProductSet = async (setId: number | string, saveData: ProductSetPayload): Promise<boolean> => {
    try {
        const response = await axios.post(`/product-sets/${setId}`, saveData);
        return response?.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const deleteProductSet = async (setId: number | string): Promise<boolean> => {
    try {
        const response = await axios.delete(`/product-sets/${setId}`);
        return response?.data?.stat || false;
    } catch (e) {
        console.error(e);
        return false;
    }
};
